/**
 * Outbound dispatch call type.
 * Used in metadata to select which agent flow runs (emergency phone tree, lease, delinquency).
 */
export var OutboundCallType;
(function (OutboundCallType) {
    OutboundCallType["EMERGENCY"] = "EMERGENCY";
    OutboundCallType["LEASING"] = "LEASING";
    OutboundCallType["DELINQUENCY"] = "DELINQUENCY";
    /** Configurable custom triggers — behavior driven entirely by the agent's own prompt. */
    OutboundCallType["WEBHOOK"] = "WEBHOOK";
})(OutboundCallType || (OutboundCallType = {}));
/** Scenario value for configurable custom triggers (agent-prompt driven). */
export const WEBHOOK_OUTBOUND_SCENARIO = 'WEBHOOK_OUTBOUND';
//# sourceMappingURL=livekit.dto.js.map